import * as React from "react";
import * as monaco from "monaco-editor";

import {
  FormStore,
  getStore,
  GraphFormStore,
} from "bundles/BigqueryQueryViewer/store";
import { observer } from "mobx-react-lite";
import { MarkerRows } from "./markerRow";
import { usePublisher } from "bundles/BigqueryQueryViewer/lib/pubsub";
import styles from "./style.module.css";

export const Problem = observer(() => {
  const store = getStore();
  const publisher = usePublisher();

  const onClickFormMarker = (
    form: FormStore,
    marker: monaco.editor.IMarkerData,
  ) => {
    publisher.publish(form, marker);
  };

  const onClickGraphFormMarker = (
    graphForm: GraphFormStore,
    marker: monaco.editor.IMarkerData,
  ) => {
    publisher.publish(graphForm, marker);
  };

  return (
    <div className={styles.root}>
      {store.forms.map((form, i) => {
        return (
          <MarkerRows
            key={i}
            filename={form.title}
            markers={form.markers}
            onClick={(marker) => onClickFormMarker(form, marker)}
          />
        );
      })}
      {store.graphForms.map((graphForm, i) => {
        return (
          <MarkerRows
            key={i}
            filename={graphForm.title}
            markers={graphForm.markers}
            onClick={(marker) => onClickGraphFormMarker(graphForm, marker)}
          />
        );
      })}
    </div>
  );
});
